<div id="step-configuration" class="menu-styler" [class.open]="styleSelectorToggle()">
  <div class="pct-c-btn">
    <a href="javascript:" (click)="styleSelectorToggle.set(!styleSelectorToggle())" [attr.aria-label]="'Abrir configuración' | translate">
      <mat-icon color="primary" class="pc-icon spin">settings</mat-icon>
    </a>
  </div>
  <div class="style-block">
    <div class="customize-header align-item-center">
      <div class="f-16 f-w-600">{{'Configuración' | translate}}</div>
      <button type="button" mat-icon-button class="close-drawer" color="warn" (click)="styleSelectorToggle.set(false)"
        [matTooltip]="'Cerrar configuración' | translate" [attr.aria-label]="'Cerrar configuración' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <ng-scrollbar style="height: calc(100vh - 85px)" visibility="hover">
      <div class="customize-body">
        <ul class="list-group">
          <li class="list-group-item">
            <div class="pc-dark">
              <div class="m-b-5 f-16 f-w-600">{{'Elige el Tema' | translate}}</div>
              <p class="text-muted">{{'Modo Claro, Oscuro o Automático' | translate}}</p>
              <div class="row">
                <div class="col-4">
                  <div class="grid">
                    <button [matTooltip]="'Modo Claro' | translate" mat-stroked-button class="customize-button"
                      [class.active]="themeService.theme() === 'light'"
                      (click)="onSetLayouts('light')" [attr.aria-label]="'Modo Claro' | translate">
                      <mat-icon class="light-icon">light_mode</mat-icon>
                    </button>
                  </div>
                </div>
                <div class="col-4">
                  <div class="grid">
                     <button [matTooltip]="'Modo Oscuro' | translate" mat-stroked-button class="customize-button"
                      [class.active]="themeService.theme() === 'dark'"
                      (click)="onSetLayouts('dark')" [attr.aria-label]="'Modo Oscuro' | translate">
                      <mat-icon class="dark-icon">dark_mode</mat-icon>
                    </button>
                  </div>
                </div>
                <div class="col-4">
                  <div class="grid">
                    <button [matTooltip]="'Modo Automático' | translate" mat-stroked-button class="customize-button"
                      [class.active]="themeService.layoutType() === 'auto'"
                      (click)="onSetLayouts('auto')" [attr.aria-label]="'Modo Automático' | translate">
                      <mat-icon class="system-icon">auto_mode</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="grid">
              <button [matTooltip]="'Restablecer diseño' | translate" mat-stroked-button
                class="bg-primary-50 text-primary-500 b-rad-20 b-primary-50"
                (click)="onResetLayout()">
                {{'Restablecer diseño' | translate}}
              </button>
            </div>
          </li>
        </ul>
      </div>
    </ng-scrollbar>
  </div>
</div>
